import React from "react";
import CategoryPage from "./CategoryPage";

export default function PpePage() {
  return (
    <CategoryPage
      categoryMatch="ppe"
      title="PPE"
      subtitle="Personal protective equipment for mining, construction, and industrial work environments."
      searchPlaceholder="Search PPE..."
    />
  );
}